import { ReactAmChart } from '../ReactAmChart';
import { arrayOf, shape, string, number } from 'prop-types';

export default class HeatMapChart extends ReactAmChart {
  static propTypes = {
    data: arrayOf(shape({
      hour: string,
      weekday: string,
      value: number
    })),
    fontColor: string,
    fontFamily: string
  }

  static defaultProps = {
    fontColor: "#757575",
    fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
  }

  drawFunction(chartId, prevChart, am4core, am4charts) {
    const { data, fontColor, fontFamily } = this.props;
    let chart = prevChart;

    if(!chart){
      chart = am4core.create(chartId, am4charts.XYChart);
      chart.maskBullets = false;

      const xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());

      xAxis.dataFields.category = "weekday";
      yAxis.dataFields.category = "hour";
      
      xAxis.renderer.grid.template.disabled = true;
      xAxis.renderer.minGridDistance = 40;
      xAxis.renderer.labels.template.fill = am4core.color(fontColor);
      xAxis.renderer.labels.template.fontSize = 12;

      yAxis.renderer.grid.template.disabled = true;
      yAxis.renderer.inversed = true;
      yAxis.renderer.minGridDistance = 30;
      yAxis.renderer.labels.template.fill = am4core.color(fontColor); 
      yAxis.renderer.labels.template.fontSize = 12;

      xAxis.fontFamily = fontFamily;
      yAxis.fontFamily = fontFamily;

      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryX = "weekday";
      series.dataFields.categoryY = "hour";
      series.dataFields.value = "value";
      series.sequencedInterpolation = true;
      series.defaultState.transitionDuration = 3000;
      series.tooltip.getFillFromObject = false;
      series.tooltip.label.fontSize = 12;
      series.tooltip.background.fill = '#ffffff';
      series.tooltip.label.fill = am4core.color('rgba(0, 0, 0, 0.87)');
      series.tooltip.tooltipContainer.exportable = false;

      const bgColor = new am4core.InterfaceColorSet().getFor("background");
      
      const columnTemplate = series.columns.template;
      columnTemplate.strokeWidth = 0.5;
      columnTemplate.strokeOpacity = 0.7;
      columnTemplate.stroke = bgColor;
      columnTemplate.tooltipText = "{weekday}, {hour}: {value.workingValue.formatNumber('#,###.##')}";
      columnTemplate.width = am4core.percent(100);
      columnTemplate.height = am4core.percent(100);
      
      series.heatRules.push({
         target: columnTemplate,
         property: "fill",
         min: am4core.color("#D5EEFE"),
         max: chart.colors.getIndex(0)
      });

      // heat legend
      const heatLegend = chart.bottomAxesContainer.createChild(am4charts.HeatLegend);
      heatLegend.width = am4core.percent(100);
      heatLegend.series = series;
      heatLegend.valueAxis.renderer.labels.template.fontSize = 10;
      heatLegend.valueAxis.renderer.labels.template.fontFamily = fontFamily;
      heatLegend.valueAxis.renderer.labels.template.fill = am4core.color(fontColor);
      heatLegend.valueAxis.renderer.minGridDistance = 50;
    }
    chart.data = data;
    return chart;
  }
}
